import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './ContactDetail.scss';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { ReactNode } from 'react';

export function ContactDetail({ name, icon, content }: ContactDetailProps) {
  return (
    <div className="contact-detail">
      <div className="name-icon">
        <FontAwesomeIcon className="icon" icon={icon as IconProp} />
        <p className="lato-thin m-0">{name}</p>
      </div>
      <div className="content">
        {content.map((content) => {
          if (content.linkTo) {
            return (
              <a
                className="lato-thin m-0"
                href={content.linkTo}
                key={content.content?.toString() ?? ''}
              >
                {content.content}
              </a>
            );
          }
          return (
            <p className="lato-thin m-0" key={content.content?.toString()}>
              {content.content}
            </p>
          );
        })}
      </div>
    </div>
  );
}
export interface ContactDetailProps {
  name: string;
  icon: string;
  content: Content[];
}
export interface Content {
  content: ReactNode;
  linkTo?: string;
}

export type ContactType = 'email' | 'phone' | 'address' | 'social';
